/* WESN Win the Armada - the countdown, the crossfading photos in the hero and the prize photo carousel. */
(function () {
  'use strict';
  function pad(n) { return (n < 10 ? '0' : '') + n; }

  /* ----- countdown ----- */
  function countdown(el) {
    var end = Date.parse(el.getAttribute('data-end') || '');
    var time = el.querySelector('[data-time]');
    var label = el.querySelector('[data-label]');
    var closedText = el.getAttribute('data-closed') || '';
    if (!end || !time) return;
    function tick() {
      var left = end - Date.now();
      if (left <= 0) {
        if (label && closedText) label.textContent = closedText;
        time.hidden = true;
        document.querySelectorAll('[data-closes-with-countdown]').forEach(function (n) { n.hidden = true; });
        return false;
      }
      var d = Math.floor(left / 86400000);
      var h = Math.floor(left % 86400000 / 3600000);
      var m = Math.floor(left % 3600000 / 60000);
      time.innerHTML = '<b>' + d + '</b>d <b>' + pad(h) + '</b>h <b>' + pad(m) + '</b>m';
      return true;
    }
    if (tick()) setInterval(tick, 30000);
  }
  document.querySelectorAll('[data-armada-countdown]').forEach(countdown);

  /* ----- hero photos: crossfade in order, pause when the tab is hidden, still if the visitor prefers reduced motion ----- */
  function slides(el) {
    var imgs = el.querySelectorAll('.armada-slide');
    if (imgs.length < 2) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return;
    var seconds = parseInt(el.getAttribute('data-seconds') || '3', 10) || 3;
    var i = 0;
    function next() {
      if (document.hidden) return;
      imgs[i].classList.remove('is-active');
      i = (i + 1) % imgs.length;
      imgs[i].classList.add('is-active');
    }
    setInterval(next, seconds * 1000);
  }
  document.querySelectorAll('[data-armada-slides]').forEach(slides);

  /* ----- prize carousel: native scroll snapping does the swipe; the buttons and marks follow it ----- */
  function carousel(el) {
    var track = el.querySelector('.armada-carousel__track');
    var slidesList = track ? track.querySelectorAll('.armada-carousel__slide') : [];
    if (!track || slidesList.length < 2) return;
    var dots = el.querySelectorAll('.armada-carousel__dot');
    var btns = el.querySelectorAll('.armada-carousel__btn');
    var count = slidesList.length;
    function current() {
      var w = track.clientWidth;
      if (!w) return 0;
      return Math.round(track.scrollLeft / w);
    }
    function goTo(n) {
      n = Math.max(0, Math.min(count - 1, n));
      track.scrollTo({ left: n * track.clientWidth, behavior: 'smooth' });
    }
    function mark() {
      var n = current();
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === n); });
    }
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        goTo(current() + (parseInt(b.getAttribute('data-dir'), 10) || 1));
      });
    });
    dots.forEach(function (d) {
      d.addEventListener('click', function () { goTo(parseInt(d.getAttribute('data-index'), 10) || 0); });
    });
    var raf = null;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = window.requestAnimationFrame(function () { raf = null; mark(); });
    });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current() + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(current() - 1); }
    });
    mark();
    window.addEventListener('load', mark);
    window.addEventListener('resize', mark);
  }
  document.querySelectorAll('[data-armada-carousel]').forEach(carousel);
})();
